import { call } from "redux-saga/effects";

import type Light from "@/models/light/light";
import { Map } from "@/utils";

import handleDuplicateFlags from "./handle-duplicate-flags/handle-duplicate-flags";

interface LoadLightsParams {
    luminaireSummary: unknown[];
    update?: boolean;
    positioningType?: string;
}

/**
 * Converts luminaire summary data from the API into light view models and flags duplicates.
 *
 * @param {LoadLightsParams} params - The parameters for loading lights, including luminaire summary, update flag,
 * and positioning type.
 * @returns The converted light view models.
 * @yields Calls duplicate detection on converted light data.
 */
function* loadLights({
    luminaireSummary,
    update = false,
    positioningType = "",
}: LoadLightsParams) {
    const lights: Light[] = luminaireSummary.map((l: unknown) =>
        Map.Converter.lights.APIToViewModel(
            l as Parameters<typeof Map.Converter.lights.APIToViewModel>[0],
            positioningType,
        ),
    );

    yield call(handleDuplicateFlags, lights, update);

    return lights;
}

export default loadLights;
